module.exports = {
  products: [
    {
      velocidade: '100 Mega',
      valor: 'R$ 79,90',
      info1: '100 MEGA DE DOWNLOAD',
      info2: '50 MEGA DE UPLOAD',
      info3: 'Wifi Turbo',
      info4: 'Conteúdo Digital',
    },
    {
      velocidade: '500 Mega',
      valor: 'R$ 99,90',
      info1: '500 MEGA DE DOWNLOAD',
      info2: '250 MEGA DE UPLOAD',
      info3: 'Wifi Turbo',
      info4: 'Conteúdo Digital',
    },
    {
      velocidade: '750 Mega',
      valor: 'R$ 119,90',
      info1: '750 MEGA DE DOWNLOAD',
      info2: '375 MEGA DE UPLOAD',
      info3: 'Wifi Turbo',
      info4: 'Conteúdo Digital',
    },
    {
      velocidade: '1000 Mega',
      valor: 'R$ 179,90',
      info1: '1000 MEGA DE DOWNLOAD',
      info2: '500 MEGA DE UPLOAD',
      info3: 'Wifi Turbo',
      info4: 'Conteúdo Digital',
    },
  ],
};